import {TutorialGuard} from './guards/tutorial.guard';
import { Routes} from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule),
        canActivate: [TutorialGuard]
    },
    {
        path: 'about',
        loadChildren: () => import('./pages/about/about.module').then(m => m.AboutPageModule)
    },
    {
        path: 'terms-condition',
        loadChildren: () => import('./pages/terms-condition/terms-condition.module').then(m => m.TermsConditionPageModule)
    },
    {
        path: 'privacy',
        loadChildren: () => import('./pages/privacy/privacy.module').then(m => m.PrivacyPageModule)
    },
    {
        path: 'notifications-setting',
        loadChildren: () => import('./pages/notifications-setting/notifications-setting.module').then(m => m.NotificationPageModule)
    },
    {
        path: 'deal-detail/:id',
        loadChildren: () => import('./pages/deal-detail/deal-detail.module').then(m => m.DealDetailPageModule)
    },
    {
        path: 'deal-detail',
        loadChildren: () => import('./pages/deal-detail/deal-detail.module').then(m => m.DealDetailPageModule)
    },
    {
        path: 'post-blog-detail',
        loadChildren: () => import('./pages/post-blog-detail/post-blog-detail.module').then(m => m.PostBlogDetailPageModule)
    },
    {
        path: 'post-blog-detail/:type/:id',
        loadChildren: () => import('./pages/post-blog-detail/post-blog-detail.module').then(m => m.PostBlogDetailPageModule)
    },
    {
        path: 'tutorial',
        loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialPageModule)
    },
    {
        path: 'guida',
        loadChildren: () => import('./pages/guida/guida.module').then(m => m.GuidaPageModule)
    },
    {
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'loginFromMenu',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
    },
    {
        path: 'blog',
        loadChildren: () => import('./pages/blog/blog.module').then(m => m.BlogPageModule)
    },
    {
        path: 'saved-list',
        loadChildren: () => import('./pages/saved-list/saved-list.module').then(m => m.SavedListPageModule)
    },
    {
        path: 'children-deals-list/:id',
        loadChildren: () => import('./pages/children-deals-list/children-deals-list.module').then( m => m.ChildrenDealsListPageModule)
    },
    {
        path: '**',
        redirectTo: ''
    }
];
